import React, { useState } from 'react';
import RestaurantImages from './components/RestaurantImages';
import CuisinesAndTiming from './components/CuisinesAndTiming'
import { updateRestaurantApi } from './Api'
import { Link } from 'react-router-dom'
import Stepper from './components/Stepper';

const EditRestro = (props) => {

    const { data } = props.location.state 
    const restaurantId = props.match.params.id
    

    const [stepNumber, setStepNumber] = useState(1);
    const [loading, setLoading] = useState(false);
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [cuisineArray, setCuisineArray] = useState(data.cuisines);



    const [thumbnailImage, setThumbnailImage] = useState(data.thumbnail);
    const [imagesArray, setImagesArray] = useState(data.restaurant_images);
    const [timingArray, setTimingArray] = useState([
        ['9 AM- 10 Am', '10 Am - 11 Am', '12-1 pm'], [], [], [], [], [], []
    ]);

    const [formData, setFormData] = useState({
        restaurant_name: data.restaurant_name,
        cuisines: data.cuisines,
        opening_timings: data.opening_timings,
        current_rating: data.current_rating,
        thumbnail: data.thumbnail,
        email: data.email,
        accountManager: data.accountManager,
        ownerName: data.ownerName,
        isHalalCertified: data.isHalalCertified,
        halalCertificate: data.halalCertificate,
        restaurant_images: data.restaurant_images,
        address: data.address,
        latitude: data.latitude,
        longitude: data.longitude,
        restaurantType: data.restaurantType,
        phone: data.phone,
        menuList: data.menuList,
        restaurant_floors: data.restaurant_floors,

    });

    const [isHalalCertified, setIsHalalCertified] = useState(false);

    //make a function to increase or decrease step number based on input type but it cannot be less than 1 and greater than 4 

    const handleStep = (e) => {
        if (e.target.name === 'next') {
            if (stepNumber < 4) {
                setStepNumber(stepNumber + 1);
            }
        } else if (e.target.name === 'prev') {
            if (stepNumber > 1) {
                setStepNumber(stepNumber - 1);
            }
        }
    }


    const handleSubmit = async (e) => {
        setLoading(true);
        setLoading(false);

        let data = {
            ...formData,
            restaurant_images: imagesArray,
            cuisines: cuisineArray,
            thumbnail: thumbnailImage,
            opening_timings: timingArray,
        }
        const res = await updateRestaurantApi(restaurantId,data);

      if(res.isError){
          alert('Error ',res.data)
      }else{
          setFormSubmitted(true);
         
      }


    }



    return (
        <div className="min-h-screen bg-gray-100  p-4 px-10 w-full">

            <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">
                Edit Restaurant
            </h2>

            <div className="w-8/12 mx-auto">
               <Stepper stepNumber={stepNumber} setStepNumber={setStepNumber}/>
            </div>

            <div className="w-9/12 mx-auto">

                {stepNumber == 1 && <div className="p-5   my-4">

                    <div className="mt-8 p-4">
                        <div>
                            <div className="flex flex-col md:flex-row">
                                <div className="w-full mx-2 flex-1 svelte-1l8159u">
                                    <div className="font-bold h-6 mt-3 text-gray-600 text-xs leading-8 uppercase"> Restaurant Name</div>
                                    <div className="bg-white my-2 p-1 flex border border-gray-200 rounded svelte-1l8159u">
                                        <input defaultValue={formData.restaurant_name} onChange={(e) => setFormData({ ...formData, restaurant_name: e.target.value })} placeholder="Just a hint.." className="p-1 px-2 appearance-none outline-none w-full text-gray-800" /> </div>
                                </div>
                                <div className="w-full mx-2 flex-1 svelte-1l8159u">
                                    <div className="font-bold h-6 mt-3 text-gray-600 text-xs leading-8 uppercase"> Restaurant Type</div>
                                    <div className="bg-white my-2 p-1 flex border border-gray-200 rounded svelte-1l8159u">
                                        <input defaultValue={formData.restaurantType} onChange={(e) => setFormData({ ...formData, restaurantType: e.target.value })} placeholder="Type cafe,dine-in,bar " className="p-1 px-2 appearance-none outline-none w-full text-gray-800" /> </div>
                                </div>
                            </div>



                            <div className="flex flex-col md:flex-row">
                                <div className="w-full mx-2 flex-1 svelte-1l8159u">
                                    <div className="font-bold h-6 mt-3 text-gray-600 text-xs leading-8 uppercase">Current Rating(Numeric ex : 4.2)</div>
                                    <div className="bg-white my-2 p-1 flex border border-gray-200 rounded svelte-1l8159u">
                                        <input defaultValue={formData.current_rating} onChange={(e) => setFormData({ ...formData, current_rating: e.target.value })} type="number" placeholder="enter rating here..." className="p-1 px-2 appearance-none outline-none w-full text-gray-800" /> </div>
                                </div>
                                <div className="w-full mx-2 flex-1 svelte-1l8159u">
                                    <div className="font-bold h-6 mt-3 text-gray-600 text-xs leading-8 uppercase"> Email</div>
                                    <div className="bg-white my-2 p-1 flex border border-gray-200 rounded svelte-1l8159u">
                                        <input  defaultValue={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} placeholder="jhon@doe.com" className="p-1 px-2 appearance-none outline-none w-full text-gray-800" /> </div>
                                </div>
                            </div>


                            <div className="flex flex-col md:flex-row">
                                <div className="w-full mx-2 flex-1 svelte-1l8159u">
                                    <div className="font-bold h-6 mt-3 text-gray-600 text-xs leading-8 uppercase">Latitude</div>
                                    <div className="bg-white my-2 p-1 flex border border-gray-200 rounded svelte-1l8159u">
                                        <input defaultValue={formData.latitude} onChange={(e) => setFormData({ ...formData, latitude: e.target.value })} type="number" placeholder="latitude" className="p-1 px-2 appearance-none outline-none w-full text-gray-800" /> </div>
                                </div>
                                <div className="w-full mx-2 flex-1 svelte-1l8159u">
                                    <div className="font-bold h-6 mt-3 text-gray-600 text-xs leading-8 uppercase">Longitude</div>
                                    <div className="bg-white my-2 p-1 flex border border-gray-200 rounded svelte-1l8159u">
                                        <input defaultValue={formData.longitude} onChange={(e) => setFormData({ ...formData, longitude: e.target.value })} type="number" placeholder="longitude" className="p-1 px-2 appearance-none outline-none w-full text-gray-800" /> </div>
                                </div>
                            </div>

                            <div className="flex flex-col md:flex-row">
                                <div className="w-full mx-2 flex-1 svelte-1l8159u">
                                    <div className="font-bold h-6 mt-3 text-gray-600 text-xs leading-8 uppercase">Phone</div>
                                    <div className="bg-white my-2 p-1 flex border border-gray-200 rounded svelte-1l8159u">
                                        <input defaultValue={formData.phone} onChange={(e) => setFormData({ ...formData, restaurantType: e.target.value })} type="phone" placeholder="enter phone here..." className="p-1 px-2 appearance-none outline-none w-full text-gray-800" /> </div>
                                </div>

                                <div className="w-full mx-2 flex-1 svelte-1l8159u">
                                    <div className="font-bold h-6 mt-3 text-gray-600 text-xs leading-8 uppercase">Address</div>
                                    <div className="bg-white my-2 p-1 flex border border-gray-200 rounded svelte-1l8159u">
                                        <input defaultValue={formData.halalCertificate} onChange={(e) => setFormData({ ...formData, address: e.target.value })} placeholder="ex : old delhi" className="p-1 px-2 appearance-none outline-none w-full text-gray-800" /> </div>
                                </div>
                            </div>


                            <div className="flex flex-col md:flex-row">
                                <div className="w-full mx-2 flex-1 svelte-1l8159u">
                                    <div className="font-bold h-6 mt-3 text-gray-600 text-xs leading-8 uppercase">Owner Name</div>
                                    <div className="bg-white my-2 p-1 flex border border-gray-200 rounded svelte-1l8159u">
                                        <input defaultValue={formData.ownerName} onChange={(e) => setFormData({ ...formData, ownerName: e.target.value })} type="email" placeholder="Name of Owner" className="p-1 px-2 appearance-none outline-none w-full text-gray-800" /> </div>
                                </div>

                                <div className="w-full mx-2 flex-1 svelte-1l8159u">
                                    <div className="font-bold h-6 mt-3 text-gray-600 text-xs leading-8 uppercase">Account Manager</div>
                                    <div className="bg-white my-2 p-1 flex border border-gray-200 rounded svelte-1l8159u">
                                        <input defaultValue={formData.accountManager} onChange={(e) => setFormData({ ...formData, accountManager: e.target.value })} placeholder="who manages account ?" className="p-1 px-2 appearance-none outline-none w-full text-gray-800" /> </div>
                                </div>
                            </div>


                            <div className="flex flex-col md:flex-row">
                                <div className="w-full mx-2 flex-1 svelte-1l8159u">
                                    <div className="font-bold h-6 mt-3 text-gray-600 text-xs leading-8 uppercase">Halal Certified ? </div>

                                    <div class="flex items-center mt-3 w-full my-12"
                                    >

                                        {isHalalCertified && <div class="relative" onClick={() => {
                                            setIsHalalCertified(false);

                                            setFormData({ ...formData, isHalalCertified: false })

                                        }} >
                                            <input checked={isHalalCertified} id="toogleA" type="checkbox" class="sr-only" />
                                            <div class="w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                                            <div class="dot absolute w-6 h-6 bg-green-400 rounded-full shadow left-4 -top-1  transition"></div>
                                        </div>

                                        }


                                        {!isHalalCertified && <div class="relative" onClick={() => {
                                            setIsHalalCertified(true);
                                            setFormData({ ...formData, isHalalCertified: true })
                                        }} >
                                            <input onChange={() => { }} checked={isHalalCertified} id="toogleA" type="checkbox" class="sr-only" />
                                            <div class="w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                                            <div class="dot absolute w-6 h-6 bg-gray-100 rounded-full shadow -left-1 -top-1  transition"></div>
                                        </div>

                                        }

                                    </div>

                                </div>

                                <div className="w-full mx-2 flex-1 svelte-1l8159u">
                                    <div className="font-bold h-6 mt-3 text-gray-600 text-xs leading-8 uppercase">Halal Certificate </div>
                                    <div className="bg-white my-2 p-1 flex border border-gray-200 rounded svelte-1l8159u">
                                        <input defaultValue={formData.halalCertificate} onChange={(e) => setFormData({ ...formData, halalCertificate: e.target.value })} placeholder="halal certificate number..." className="p-1 px-2 appearance-none outline-none w-full text-gray-800" /> </div>
                                </div>
                            </div>




                        </div>
                    </div>
                </div>
                }
            </div>

            <div className="w-10/12 mx-auto">
                {stepNumber == 2 && <RestaurantImages thumbnailImage={thumbnailImage} setThumbnailImage={setThumbnailImage} imagesArray={imagesArray} setImagesArray={setImagesArray} />}
            </div>


            <div className="w-10/12 mx-auto">
                {stepNumber == 3 && <CuisinesAndTiming timingArray={timingArray} setTimingArray={setTimingArray} cuisineArray={cuisineArray} setCuisineArray={setCuisineArray} />}
            </div>


            <div className="w-10/12 mx-auto">
                {stepNumber == 4 && <div className="my-20 w-full text-center">
                    {!formSubmitted && <h4 className="text-lg">Are you Sure you want to submit details ?</h4>}

                    {loading &&
                        <div className=" flex justify-center items-center">
                            <div className="animate-spin rounded-full h-20 w-20 border-t-2 border-b-2 border-purple-500" />
                        </div>
                    }

                    {formSubmitted && <div><div class="bg-green-500 border-t-4 w-60% mx-auto border-green-500 rounded-b text-white px-4 py-3 shadow-md" role="alert">
                        <div class="flex">
                            <div class="py-1"><svg class="fill-current h-6 w-6 text-teal-500 mr-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z" /></svg></div>
                            <div>
                                <p class="font-bold">Restaurant Updated Successfully !</p>
                                <p class="text-sm">Start Adding Floors and Seating Arrangements !.</p>
                            </div>
                        </div>
                    </div>


                      <Link to={`/restaurantfloors/${restaurantId}`} >  <button className="text-base mx-auto mt-10 bg-purple-500 text-white font-medium border hover:scale-110 focus:outline-none flex justify-center px-4 py-2 rounded  cursor-pointer 
                         ">Create Seating & Floors</button></Link>

                    </div>
                    }
                </div>
                }
            </div>










            {!formSubmitted && <div className="flex p-8 w-10/12 relative  bottom-10   mx-auto   mt-5">
                <button name="prev" onClick={(e) => handleStep(e)} className="text-base border hover:scale-110 focus:outline-none flex justify-center px-4 py-2 rounded font-medium cursor-pointer 
                                     ">Previous</button>

                <div className="flex-auto flex flex-row-reverse">

                    {stepNumber == 4 && <button onClick={() => handleSubmit()} className="text-base mx-3 bg-purple-500 text-white font-medium border hover:scale-110 focus:outline-none flex justify-center px-4 py-2 rounded  cursor-pointer 
                                     ">Update Restaurant</button>
                    }

                   

                    <button name="next" onClick={(e) => handleStep(e)} className="text-base border hover:scale-110 focus:outline-none flex justify-center px-4 py-2 rounded font-medium cursor-pointer 
                                     ">Next </button>

                </div>
            </div>}



        </div>
    );
}

export default EditRestro;
